import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

export function Loading(props) {
  const dots = _.map(_.range(5), num => <div key={num} />);

  return (
    <div className="loading-dialog">
      <div className="progress-translucent loading-dots-container">
        {dots}
      </div>
      <div className="loading-text">
        <p>{props.text}</p>
      </div>
    </div>
  );
}

Loading.propTypes = {
  text: PropTypes.string,
};

Loading.defaultProps = {
  text: 'Loading...',
};
